import { IHistoryRecord } from "./IHistoryRecord";

export interface INameHistorySpecifiable {
  nameHistories: IHistoryRecord<IObjectNameIdentifier>[];
}

// 名称履歴はオブジェクトによって格納する情報が違う...しかたないので対応できる構造にする.
export interface IObjectNameIdentifier {
  name?: string;
  key?: string;
  subKey?: string;
}

export function instanceOfINameHistorySpecifiable(instance: any): instance is INameHistorySpecifiable {
  return instance
    && (instance.nameHistories !== undefined);
}
